function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h240v240H0z"
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  strokeWidth: 3,
  fill: "#C0D0D8",
  cx: 127.222,
  cy: 38.799,
  rx: 15.556,
  ry: 15.574
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  strokeWidth: 3,
  fill: "#C0D0D8",
  cx: 139.444,
  cy: 58.822,
  rx: 15.556,
  ry: 15.574
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  strokeWidth: 3,
  cx: 51.667,
  cy: 120.006,
  rx: 5.556,
  ry: 5.562
}), /*#__PURE__*/React.createElement("path", {
  d: "M191.854 129.329c17.15.018 14.517.008 19.207.078 4.691.07 7.348-1.873 7.971-5.569l-.068-16.703c-.01-3.124.223-6.255-1.439-9.137-3.528-6.118-11.295-8.241-17.349-4.742-6.053 3.5-8.1 11.295-4.572 17.414a12.797 12.797 0 009.375 6.313c9.085.057 15.908.085 20.467.083 4.938-.001 5.366-4.032 5.517-7.573.1-2.361-.195-13.049-.084-20.635",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "#371447",
  strokeWidth: 3,
  fill: "#C0D0D8",
  x: 97.611,
  y: 93.695,
  width: 52.556,
  height: 7.012,
  rx: 3.506
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.114 122.486h12.672c6.422-19.935 16.125-32.401 38.325-38.078.067-4.558-.101-20.757 0-23.172 18.025-.422 25.001 8.63 25 23.172 39.958.07 18.657-3.292 47.5 0 28.843 3.293 51.729 19.77 54.193 51.272-.334 21.774-5.14 40.14-35.582 52.184-.11-.199.054 1.38 0 14.246-.034 8.158-27.027 8.158-27.049 0v-14.246h-26.541l.118 14.246c-.422 8.148-27.404 8.169-27.314 0v-14.246c-23.046-1.76-37.127-9.025-44.466-27.288-.429.04-5.029.027-14.418 0-7.701.985-11.615-4.797-11.743-17.347-.128-12.55 2.974-19.465 9.305-20.743z",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("g", {
  fill: "#371447"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -336.973 220.292)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -347.035 234.988)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -354.731 251.05)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -349.731 269.71)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -344.731 288.37)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -303.143 307.299)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 16,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 8,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 24,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 30,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -324.401 326.923)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -329.731 344.351)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -324.731 363.012)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -319.731 381.672)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -311 399.332)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
}))), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  strokeWidth: 3,
  fill: "#C0D0D8",
  cx: 121.667,
  cy: 36.574,
  rx: 15.556,
  ry: 15.574
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  strokeWidth: 3,
  fill: "#C0D0D8",
  cx: 133.889,
  cy: 58.822,
  rx: 15.556,
  ry: 15.574
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.298 100.668a14.939 14.939 0 01-.41-3.48c0-8.388 6.94-15.188 15.5-15.188 8.561 0 15.5 6.8 15.5 15.188 0 1.316-.17 2.594-.492 3.812l-30.098-.332z",
  stroke: "#371447",
  strokeWidth: 3,
  fill: "#C0D0D8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.744 100.214a15.637 15.637 0 01-.41-3.569c0-8.601 6.964-15.574 15.555-15.574s15.555 6.973 15.555 15.574c0 1.35-.171 2.66-.494 3.91l-30.206-.341z",
  stroke: "#371447",
  strokeWidth: 3,
  fill: "#C0D0D8"
}));

function SvgCoreSavingsXl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgCoreSavingsXl;